import styled from 'styled-components/native';

export default styled.Image`
  border: 0.5px solid rgba(255, 255, 255, 0.52);
  width: 140px;
  height: 140px;
  border-radius: 70px;
  margin-bottom: 32px;
`;
